import { ReactNode } from 'react';
import NavigationButton, { NavigationButtonProps } from './NavigationButton';

export interface PlatformNavigationProps
  extends Omit<NavigationButtonProps, 'icon'> {
  children?: ReactNode;
}

export const PlatformNavigation = ({
  label,
  id,
  onClick,
  active = false,
  children,
}: PlatformNavigationProps) => {
  return (
    <NavigationButton
      icon='mdi:google-earth'
      label={label}
      id={id}
      onClick={onClick}
      active={active}
    >
      {children}
    </NavigationButton>
  );
};

export default PlatformNavigation;
